import React, { useState } from 'react';
import styles from './index.module.scss';

const ContactsSliderBlock = ({ blockData, path_to_folder, blockIndex }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  // Выводим данные для отладки

  // Получаем контент с индексом 0 для слайдера (imgs_block)
  const sliderContent =
    blockData && blockData.block_content && Array.isArray(blockData.block_content)
      ? blockData.block_content[0]
      : null;
  // Получаем контент с индексом 1 для подписи (text)
  const captionContent =
    blockData && blockData.block_content && Array.isArray(blockData.block_content)
      ? blockData.block_content[1]
      : null;

  // Обработка imgsNames для слайдера (логика из imgs_block_components)
  const processedImgsNames = React.useMemo(() => {
    if (!sliderContent || !sliderContent.imgs_names) return [];

    const imgsNames = sliderContent.imgs_names;

    if (imgsNames === '' || imgsNames === '[]' || imgsNames === 'none') return [];

    let imagesArray = [];

    // Если это строка, пытаемся распарсить как JSON
    if (typeof imgsNames === 'string') {
      try {
        imagesArray = JSON.parse(imgsNames);
      } catch (e) {
        // Если не JSON, разделяем по запятым
        imagesArray = imgsNames
          .split(',')
          .map((img) => img.trim())
          .filter((img) => img && img !== 'none');
      }
    } else if (Array.isArray(imgsNames)) {
      imagesArray = imgsNames.filter((img) => img && img !== 'none');
    }

    // Обрабатываем каждый путь изображения
    return imagesArray.map((imgName) => {
      if (imgName && imgName.includes('\\')) {
        return imgName.substring(imgName.lastIndexOf('\\') + 1);
      }
      return imgName;
    });
  }, [sliderContent]);

  // Получаем текст подписи (логика из text_components)
  const captionText = captionContent?.content_text || null;

  // Ранний возврат после всех хуков
  if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  // Функции управления слайдером
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % processedImgsNames.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + processedImgsNames.length) % processedImgsNames.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Определяем, нужен ли слайдер (больше одного изображения)
  const needSlider = processedImgsNames && processedImgsNames.length > 1;
  const hasSingleImage = processedImgsNames && processedImgsNames.length === 1;

  return (
    <div className={styles.contactsSliderBlock}>
      {/* Слайдер изображений (если больше одного) */}
      {needSlider && (
        <div className={styles.sliderContainer}>
          <div className={styles.slider}>
            <div
              className={styles.slidesWrapper}
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {processedImgsNames.map((processedImgName, index) => (
                <div key={`slide-${index}`} className={styles.slide}>
                  <img
                    src={path_to_folder + processedImgName}
                    alt={`Контакт ${index + 1}`}
                    className={styles.slideImage}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Кнопки навигации */}
          <button className={styles.prevButton} onClick={prevSlide} aria-label='Previous slide'>
            &#8249;
          </button>
          <button className={styles.nextButton} onClick={nextSlide} aria-label='Next slide'>
            &#8250;
          </button>

          {/* Индикаторы */}
          <div className={styles.indicators}>
            {processedImgsNames.map((_, index) => (
              <button
                key={index}
                className={`${styles.indicator} ${index === currentSlide ? styles.active : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      )}

      {/* Одиночное изображение */}
      {hasSingleImage && (
        <div className={styles.singleImageWrapper}>
          <img
            src={path_to_folder + processedImgsNames[0]}
            alt='Контакт'
            className={styles.singleImage}
          />
        </div>
      )}

      {/* Подпись */}
      {captionText && captionText !== 'none' && (
        <div className={styles.captionContainer}>
          <p className={styles.captionText}>{captionText}</p>
        </div>
      )}
    </div>
  );
};

export default ContactsSliderBlock;
